module.exports = __webpack_public_path__ + "static/media/upload_more.3fb5e033.svg";